import { render } from "./PedidoDetalle.vue?vue&type=template&id=b2918d20"
import script from "./PedidoDetalle.vue?vue&type=script&lang=js"
export * from "./PedidoDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__